import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Separator } from '@/components/ui/separator'
import { Automation } from '../schema'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  automation: Automation | null
}

export function AutomationStatsDialog({
  open,
  onOpenChange,
  automation,
}: Props) {
  if (!automation) return null

  const lastExecutionDate = automation.stats.lastExecution
    ? format(
        new Date(automation.stats.lastExecution),
        "dd/MM/yyyy 'às' HH:mm",
        {
          locale: ptBR,
        }
      )
    : 'Nunca executada'

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-md'>
        <DialogHeader>
          <DialogTitle>Estatísticas da Automação</DialogTitle>
          <DialogDescription>{automation.name}</DialogDescription>
        </DialogHeader>
        <div className='space-y-4'>
          <div className='flex items-center justify-between'>
            <span className='text-sm font-medium'>Status:</span>
            <Badge variant={automation.isActive ? 'default' : 'destructive'}>
              {automation.isActive ? 'Ativo' : 'Inativo'}
            </Badge>
          </div>
          <Separator />
          <div className='flex items-center justify-between'>
            <span className='text-sm font-medium'>Total de Execuções:</span>
            <span className='text-2xl font-bold'>
              {automation.stats.executionCount}
            </span>
          </div>
          <Separator />
          <div className='flex items-center justify-between'>
            <span className='text-sm font-medium'>Taxa de Sucesso:</span>
            <span className='text-2xl font-bold'>
              {automation.stats.successRate.toFixed(1)}%
            </span>
          </div>
          <Separator />
          <div className='space-y-1'>
            <span className='text-sm font-medium'>Última Execução:</span>
            <p className='text-sm text-muted-foreground'>{lastExecutionDate}</p>
          </div>
          <Separator />
          <div className='space-y-1'>
            <span className='text-sm font-medium'>Tipo de Trigger:</span>
            <p className='text-sm text-muted-foreground'>
              {automation.triggerType === 'KEYWORD' && 'Palavra-chave'}
              {automation.triggerType === 'EVENT' && 'Webhook'}
              {automation.triggerType === 'CONDITION' && 'Segmento'}
            </p>
          </div>
          <Separator />
          <div className='space-y-1'>
            <span className='text-sm font-medium'>Tipo de Ação:</span>
            <p className='text-sm text-muted-foreground'>
              {automation.actionType === 'ROUTING' && 'Disparar Fluxo'}
              {automation.actionType === 'AGENT' && 'Executar Agente IA'}
            </p>
          </div>
        </div>
        <DialogFooter className='sm:justify-end'>
          <DialogClose asChild>
            <Button type='button' variant='secondary'>
              Fechar
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
